/**
 * 天地图 JS API 4.0 共享加载器（单例 script 注入）
 *
 * 官方加载方式（第一手，lbs.tianditu.gov.cn/api/js4.0 示例）：
 *   <script src="https://api.tianditu.gov.cn/api?v=4.0&tk=您的密钥"></script>
 *   加载成功后全局暴露 window.T（T.Map / T.Marker / T.LngLat ...）
 *
 * 约束沿袭 amap-loader 的成熟纪律：模块级单例 promise，全应用只注一次 <script>；
 * onerror / 10s 超时释放单例允许下次重试；无插件机制、无 securityConfig（天地图无此概念）。
 *
 * tk（浏览器端 Key）由后端 /api/map/config 运行时下发，调用方传入，不进本文件、不进 bundle。
 */

let loadPromise = null

/**
 * 加载天地图 JS API
 * @param {Object} opts { key } 浏览器端 tk
 * @returns {Promise<T>} 就绪后 resolve 全局 T 命名空间
 */
export function loadTianditu (opts) {
  const key = opts && opts.key
  if (!key) return Promise.reject(new Error('tianditu_no_key'))
  if (typeof window === 'undefined') return Promise.reject(new Error('no_window'))
  if (window.T && window.T.Map) return Promise.resolve(window.T)
  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve, reject) => {
    let settled = false
    const done = (fn, arg) => {
      if (settled) return
      settled = true
      fn(arg)
    }
    const fail = (err) => {
      loadPromise = null // 释放单例：失败可重试
      done(reject, err)
    }

    const s = document.createElement('script')
    s.src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=' + encodeURIComponent(key)
    s.onerror = function () { fail(new Error('tianditu_load_fail')) }

    // script.onload 后 SDK 同步注册 window.T；短轮询兜底异步注册，整体 10s 超时
    const startedAt = Date.now()
    const poll = () => {
      if (settled) return
      if (window.T && window.T.Map) return done(resolve, window.T)
      if (Date.now() - startedAt > 10000) return fail(new Error('tianditu_load_timeout'))
      setTimeout(poll, 50)
    }
    s.onload = poll
    document.head.appendChild(s)
    setTimeout(poll, 100) // 个别浏览器 onload 不可靠，双保险
  })
  return loadPromise
}
